
define('text!templates/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-content.html',[],function () { return '<div class="sets-count">\n    <span class="set-num" data-bind="html:week_numSets"></span>\n    <span class="set-translation">{{setsTranslation}}</span>\n</div>\n<table class="exercise-weight-table table"></table>\n';});

